import { render, staticRenderFns } from "./ImportLayout.vue?vue&type=template&id=0e983b60&scoped=true"
import script from "./ImportLayout.vue?vue&type=script&lang=js"
export * from "./ImportLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e983b60",
  null
  
)

export default component.exports